// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1520":"3d64c3cb1ac73562","3484":"0ef01fae14458aa4","5241":"b1db438ce85dff3f","6399":"34f11f4d513f0555"}[chunkId] + ".css";
};